<template>
  <main id="content">
    <DeckShuffle />
  </main>
</template>

<script setup lang="ts">
definePageMeta({ layout: false });

useHead({
  title: 'Reclaim Your Thoughts — Own Your Mindset',
  meta: [
    {
      name: 'description',
      content: 'Pick a card for a little lift and reclaim your thoughts.'
    }
  ]
});
</script>
